/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { sha256 } from "crypto-hash";
import CryptoJS from 'crypto-js';
import { Amplify } from 'aws-amplify';
import {
  signIn,
  confirmSignIn,
  fetchUserAttributes,
  fetchAuthSession,
  updateMFAPreference,
} from 'aws-amplify/auth';
import { withMsal } from '@azure/msal-react';
import { EventType } from '@azure/msal-browser';
import { Alert, Button, Row, Col, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { accountActions } from '../../../actions';
import { Navigate, NavLink } from 'react-router-dom';
import Spinners from '../../../components/Spinners';
import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';
import { EulaContent } from '../../../constants/common.constants';
import { msalConfig } from '../../../authConfig';
import { msalConfigProd } from '../../../authConfigProd';
import { commonConstants } from '../../../constants';
import { genPassword, withRouter } from '../../../helpers';
import {
  RichTextEditorComponent,
  HtmlEditor,
  Table,
  Inject,
  Toolbar,
  Link,
  Image,
  QuickToolbar,
} from '@syncfusion/ej2-react-richtexteditor';

import './Login.scss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

let logsToCopy = '';
class Login extends Component {
  constructor(props) {
    logsToCopy = '';
    super(props);
    this.handleVerify = this.handleVerify.bind(this);
    this.updateInput = this.updateInput.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.Otpclose = this.Otpclose.bind(this);
    this.setWithExpiry = this.setWithExpiry.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.getWithExpiry = this.getWithExpiry.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.state = {
      consentCheck: null,
      password: '',
      username: '',
      otpModal: false,
      projectName: 'Auditor',
      resetPasswordModal: false,
      newPassword: '',
      confirmPassword: '',
      NewPasswordErrorMessage: '',
      validatedRules: {},
      isValidationPopupWindowOpen: false,
      timeoutModal: false,
      key: '',
      validationError: false,
      otp: null,
      eulaAccepted: true,
      EULAContent: EulaContent,
      loginInProcess: false,
      displayWelcomeMessage: false,
      redirectToReferrer: false,
      checkingSession: true,
    };
    this.user = null;
    this.toolbarSettings = {
      enable: false,
      items: this.items,
      type: 'MultiRow',
    };
    this.date = new Date().getDate() + new Date().getMonth() + new Date().getFullYear();
    this.currentKey = Base64.stringify(hmacSHA512(this.date, 'pk-client'));
    this.currentKey = this.currentKey.substr(0, 5);
    this.clearLoginTimeout = this.clearLoginTimeout.bind(this);
    this.changeKey = this.changeKey.bind(this);
    this.acceptEula = this.acceptEula.bind(this);
    this.logout = this.logout.bind(this);
    this.rejectEula = this.rejectEula.bind(this);
    this.getSession = this.getSession.bind(this);
    this.updateCognitoUser = this.updateCognitoUser.bind(this);
    this.microsoftLogin = this.microsoftLogin.bind(this);
    this.register = this.register.bind(this);
    this.encrypt = this.encrypt.bind(this);
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.authenticateWithMicrosoftToken = this.authenticateWithMicrosoftToken.bind(this);
    this.clearTwilioToken = this.clearTwilioToken.bind(this);
    this.checkExistingSession = this.checkExistingSession.bind(this);
    this.otpAPIVerificationCode =
      [...new Array(10)]
        .map(() => {
          const crypto = window.crypto || window.msCrypto;
          let array = new Uint32Array(1);
          return crypto.getRandomValues(array)[0].toString(36)[2];
        })
        .join('') +
      '_' +
      Date.now();
  }

  copyToClipboard(textToCopy) {
    navigator.clipboard.writeText(textToCopy).then(
      () => {},
      () => {}
    );
  }

  encrypt(text) {
    let derived_key = CryptoJS.enc.Base64.parse('6YOACrfcFLi1hlHplfxTnR/NtJ7L0Wa8DRTBqLnbDpU=');
    let iv = CryptoJS.enc.Utf8.parse('1020304050607080');
    return CryptoJS.AES.encrypt(text, derived_key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString();
  }

  microsoftLogin() {
    try {
      localStorage.removeItem('userInitiatedLogout');
      localStorage.setItem('login_option', 'new');
      Amplify.configure(config);

      const isProduction = commonConstants.IS_PRODUCTION_SITE;
      let loginParams = isProduction ? msalConfigProd : msalConfig;

      const msalInstance = this.props.msalContext?.instance;
      if (!msalInstance) {
        return;
      }

      msalInstance
        .loginRedirect(loginParams)
        .then(() => {})
        .catch((err) => {});
    } catch (err) {}
  }

  authenticateWithMicrosoftToken = async () => {
    let accounts = this.props.msalContext.accounts;

    if (accounts[0]?.username) {
      const userName = accounts[0]?.username?.toLowerCase();

      this.setState({ loginInProcess: true, username: userName.toLowerCase().trim() });
      this.props.showLoader();

      try {
        // Step 1: Initiate sign in with custom auth flow
        const signInResult = await signIn({
          username: userName,
          options: {
            authFlowType: 'CUSTOM_WITHOUT_SRP', // or 'CUSTOM_WITH_SRP' depending on your backend
          },
        });

        logsToCopy = logsToCopy + '****** cognito sign in response ' + JSON.stringify(signInResult);

        // Step 2: Check if custom challenge is required
        if (signInResult.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE') {
          // Send Microsoft token as challenge answer
          try {
            const confirmResult = await confirmSignIn({
              challengeResponse: this.state.idToken,
            });

            this.props.hideLoader();

            if (confirmResult.isSignedIn) {
              localStorage.setItem('QCBD', 'ERTM');

              // Fetch user attributes after successful sign-in
              fetchUserAttributes()
                .then((attributes) => {
                  this.getSession({ attributes });
                })
                .catch((attrError) => {
                  this.setState({
                    loginInProcess: false,
                    loginError: 'Failed to fetch user information. Please try again.',
                  });
                });
            } else {
              // Handle any additional steps if needed
            }
          } catch (confirmError) {
            this.setState({
              loginInProcess: false,
              loginError: 'Sorry, this user does not exist. Please contact your administrator.',
            });
            this.props.hideLoader();
          }
        } else {
        }
      } catch (signInError) {
        logsToCopy = logsToCopy + '****** cognito sign in response ' + JSON.stringify(signInError);

        // Handle UserAlreadyAuthenticatedException
        if (signInError.name === 'UserAlreadyAuthenticatedException') {
          try {
            // Sign out the existing session
            await this.props.logout(() => {});
            // Retry the authentication
            this.authenticateWithMicrosoftToken();
            return;
          } catch (logoutError) {
            this.setState({
              loginInProcess: false,
              loginError: 'Failed to clear existing session. Please try again.',
            });
            this.props.hideLoader();
            return;
          }
        }

        this.setState({
          loginInProcess: false,
          loginError: 'Authentication failed. Please try again.',
        });
        this.props.hideLoader();
      }
    } else {
      let usernames = accounts.map((a) => a.username);
      usernames = usernames.join(',');

      this.setState({
        loginInProcess: false,
        loginError:
          'Sorry, this user does not exist. Please contact your administrator : ' + usernames,
      });
    }
  };

  async checkExistingSession() {
    try {
      const sessionMarker = localStorage.getItem('QCBD');

      if (sessionMarker === 'ERTM') {
        return new Promise((resolve) => {
          this.props.getSession((err, data) => {
            if (!err) {
              let eulaAccepted = localStorage.payload
                ? JSON.parse(localStorage.payload)['custom:eulaAccepted']
                : null;

              if (eulaAccepted && eulaAccepted !== '0') {
                this.setState({
                  checkingSession: false,
                  redirectToReferrer: true,
                });
                resolve(true);
              } else {
                this.setState({
                  checkingSession: false,
                  eulaAccepted: false,
                });
                resolve(true);
              }
            } else {
              this.setState({ checkingSession: false });
              resolve(false);
            }
          });
        });
      } else {
      }
    } catch (error) {}

    this.setState({ checkingSession: false });
    return false;
  }

  async componentDidMount() {
    localStorage.removeItem('AzureRegistration');

    let msalInstance = this.props.msalContext.instance;

    const userInitiatedLogout = localStorage.getItem('userInitiatedLogout');

    // Default to using the first account if no account is active on page load
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
      if (userInitiatedLogout !== 'true') {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
      }
    }

    // Listen for sign-in event and set active account
    msalInstance.addEventCallback((event) => {
      logsToCopy = logsToCopy + '****** microsoft sign in response ' + JSON.stringify(event);

      const userInitiatedLogout = localStorage.getItem('userInitiatedLogout');
      if (userInitiatedLogout === 'true') {
        return;
      }

      if (
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS &&
        event.payload &&
        event.payload.idToken &&
        event.payload.account
      ) {
        this.setState(
          {
            username: event.payload.account.username.toLowerCase().trim(),
            idToken: event.payload.idToken,
          },
          () => {
            const account = event.payload.account;
            msalInstance.setActiveAccount(account);
            this.register();
          }
        );
      } else if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload.account &&
        event.payload.account
      ) {
        this.setState(
          {
            username: event.payload.account.username.toLowerCase().trim(),
            idToken: event.payload.idToken,
          },
          () => {
            const account = event.payload.account;
            msalInstance.setActiveAccount(account);
            this.register();
          }
        );
      } else {
        logsToCopy = logsToCopy + '****** microsoft sign in error' + JSON.stringify(event);
      }
    });

    // Process redirect when returning from Microsoft login
    try {
      const redirectResult = await msalInstance.handleRedirectPromise();

      const userInitiatedLogout = localStorage.getItem('userInitiatedLogout');
      if (userInitiatedLogout === 'true') {
        const accounts = msalInstance.getAllAccounts();
        accounts.forEach((account) => {
          msalInstance.setActiveAccount(null);
        });
        localStorage.removeItem('userInitiatedLogout');
        this.setState({ checkingSession: false });
        return;
      }

      if (redirectResult && redirectResult.account) {
        const account = redirectResult.account;
        const idToken = redirectResult.idToken;
        msalInstance.setActiveAccount(account);
        this.setState(
          prevState => ({
            username: account.username.toLowerCase().trim(),
            idToken: idToken || prevState.idToken,
            checkingSession: false,
          }),
          () => {
            this.register();
          }
        );
        return;
      }
    } catch (redirectError) {}

    const hasActiveSession = await this.checkExistingSession();

    if (hasActiveSession) {
      return;
    }

    this.clearTwilioToken();
    localStorage.removeItem('QCBD');
  }

  async clearTwilioToken() {
    this.twilioToken = 'twilio'; //await sha256("twilio")
    this.twilioToken = '_' + this.twilioToken;
    // localStorage.removeItem(this.twilioToken);
  }

  register() {
    let username = this.state.username;
    let msalIdtoken = this.state.idToken;

    let user = {
      username,
      email: username,
      msalIdtoken,
      password: genPassword(),
    };

    logsToCopy = logsToCopy + '****** register request body : ' + JSON.stringify(user);

    this.props.register(user, (error, response) => {
      logsToCopy = logsToCopy + '****** cognito sign up error :' + JSON.stringify(error);
      logsToCopy = logsToCopy + '****** congito sign up response : ' + JSON.stringify(response);

      if (error != 'UsernameExistsException: User already exists') {
        this.setState({ displayWelcomeMessage: true });
      } else {
      }

      this.authenticateWithMicrosoftToken(msalIdtoken);
    });
  }

  async updateCognitoUser(callback) {
    const newUserPool = localStorage.login_option === 'new';
    const username = this.state.username;
    const ip = 'placeholderForIp';
    const userInfo = `${ip}###${genPassword()}`;

    const data = {
      item: {
        username,
        attributes: {
          'custom:eulaAccepted': '1',
          'custom:userInfo': userInfo,
        },
        newUserPool,
      },
    };

    this.props.updateCognitoUser(data, (error) => {
      if (!error) {
        localStorage.setItem('userInfo', userInfo);
        if (callback) callback();
      }
    });
  }

  rejectEula() {
    this.logout();
  }

  logout() {
    localStorage.setItem('userInitiatedLogout', 'true');
    this.props.logout((error) => {
      if (!error) {
        this.setState(
          {
            eulaAccepted: true,
          },
          () => {
            if (localStorage.AzureRegistration == '1') {
              localStorage.clear();
              sessionStorage.clear();
              localStorage.setItem('AzureRegistration', '1');
              localStorage.setItem('userInitiatedLogout', 'true');
            } else {
              localStorage.clear();
              sessionStorage.clear();
              localStorage.setItem('userInitiatedLogout', 'true');
            }

            if (localStorage.AzureRegistration == '1') {
              this.microsoftLogin();
            }
          }
        );
      }
    });
  }

  acceptEula() {
    this.updateCognitoUser(() => {
      this.setState(
        {
          eulaAccepted: true,
          redirectToReferrer: true,
        },
        () => {
          if (this.state.displayWelcomeMessage) {
            localStorage.setItem('AzureRegistration', '1');
            this.logout();
          }
        }
      );
    }).catch(() => {});
  }
  Otpclose() {
    // Reset loginInProcess as well so that closing the OTP modal returns
    // the user to the login form instead of the "Signing in" spinner.
    this.setState({
      otpModal: false,
      resetPasswordModal: false,
      otp: '',
      loginInProcess: false,
    });
  }
  async handleVerify() {
    this.setState({ loginInProcess: true });

    // Check for Amplify v6 format first
    if (this.user && this.user.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_SMS_CODE') {
      try {
        const confirmResult = await confirmSignIn({
          challengeResponse: this.state.otp,
        });

        if (confirmResult.isSignedIn) {
          this.setState({ loginInProcess: false, otpModal: false, otp: '' });

          this.props.showLoader();

          const attributes = await fetchUserAttributes();

          this.user.attributes = attributes;

          await this.updateCognitoUser(() => {
            localStorage.setItem('QCBD', 'ERTM');
            this.getSession({ attributes });
          });
        } else {
          this.setState({
            loginInProcess: false,
            otpError: error?.message || 'OTP verification failed. Please try again.',
          });
          this.props.hideLoader();
        }
      } catch (error) {
        this.setState({
          loginInProcess: false,
          otpError: error?.message || 'OTP verification failed. Please try again.',
        });
        this.props.hideLoader();
      }
    } else {
      // Handle custom SMS OTP (existing flow)
      this.props.verifySMSOTP(
        {
          mobileNumber: this.mobileNumber,
          otp: this.state.otp,
          code: this.otpAPIVerificationCode,
        },
        (error, response) => {
          const isValid = this.isValidOTPResponse(error, response);

          if (isValid) {
            localStorage.setItem('temp-session', response?.code);
            this.handleSuccessfulOTPVerification();
          } else {
            this.setState({
              otpError: 'OTP verfication failed',
              loginInProcess: false,
            });
          }
        }
      );
    }
  }

  isValidOTPResponse(error, response) {
    return !error && response['code'] && response['code'] == this.otpAPIVerificationCode;
  }

  handleSuccessfulOTPVerification() {
    this.setState({ otpModal: false, otp: '' }, () => {
      this.updateCognitoUser(() => {
        localStorage.setItem('QCBD', 'ERTM');
        this.getSession(this.user);
      }).catch(() => {});
    });
  }

  handleLogin(e) {
    localStorage.clear();
    sessionStorage.clear();
    this.setState({ loginError: '' });

    e.preventDefault();

    // Guard against double submission
    if (this.state.loginInProcess) {
      return;
    }

    // Clear only error state, not all storage
    this.setState({
      loginError: '',
      loginInProcess: true,
    });

    // Configure Amplify for old user pool
    localStorage.setItem('login_option', 'old');

    try {
      Amplify.configure(config_old);
    } catch (configError) {
      this.setState({
        loginError: 'Configuration error. Please try again.',
        loginInProcess: false,
      });
      return;
    }

    this.props.login(this.state, (err, response) => {
      if (!err) {
        this.user = response;

        if (response.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_SMS_CODE') {
          // SMS MFA is required - show OTP modal
          this.mobileNumber = response.nextStep.codeDeliveryDetails?.destination || '';
          this.setState({
            otpModal: true,
            loginInProcess: false,
            loginError: '',
          });
          this.props.hideLoader();
          toast.success(`OTP sent to ${this.mobileNumber}`);
          return;
        } else if (response.challengeName === 'NEW_PASSWORD_REQUIRED') {
          // User needs to set new password first - don't fetch attributes yet
          this.setState({
            resetPasswordModal: true,
            NewPasswordErrorMessage: '',
            newPassword: '',
            confirmPassword: '',
            validatedRules: {},
            loginInProcess: false,
            loginError: '',
          });
          this.props.hideLoader();
        } else if (response.nextStep?.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
          // AWS Amplify v6 format for new password required
          this.setState({
            resetPasswordModal: true,
            NewPasswordErrorMessage: '',
            newPassword: '',
            confirmPassword: '',
            validatedRules: {},
            loginInProcess: false,
            loginError: '',
          });
          this.props.hideLoader();
        } else if (response.isSignedIn === true) {
          // Only fetch attributes when user is fully authenticated
          this.props.showLoader();
          fetchUserAttributes()
            .then(async (attributes) => {
              this.user.attributes = attributes;

              this.mobileNumber = attributes?.phone_number || '';
              const userSub = attributes?.sub || '';

              // CRITICAL FIX: Cache the Amplify session before making API calls
              // This ensures that when sendSMSOTP calls apiUtils.postRequest(),
              // Amplify's post() function can retrieve the session for Authorization header
              try {
                await fetchAuthSession({ forceRefresh: true });
              } catch (sessionError) {
                // Continue anyway - the API call might still work
              }

              const otpPayload = {
                email: this.state.username,
                mobileNumber: this.mobileNumber,
                sub: userSub,
                code: this.otpAPIVerificationCode,
              };

              this.props.sendSMSOTP(otpPayload, (err, response) => {
                if (
                  response &&
                  response['success'] &&
                  response['code'] &&
                  response['mobileNumber'] &&
                  response['sub'] &&
                  response['code'] == this.otpAPIVerificationCode
                ) {
                  this.user.attributes = {
                    ...this.user.attributes,
                    sub: response['sub'],
                    phone_number: response['mobileNumber'],
                  };
                  this.mobileNumber = response['mobileNumber'];
                  this.setState({ otpModal: true, loginInProcess: false });
                  toast.success(response?.msg);
                } else {
                  // Reset loginInProcess so the user is not stuck on the
                  // "Signing in" spinner when SMS OTP dispatch fails.
                  this.setState({
                    loginInProcess: false,
                    loginError:
                      response?.msg || 'Failed to send verification code. Please try again.',
                  });
                  this.props.hideLoader();
                  toast.error(
                    response?.msg || 'Failed to send verification code. Please try again.'
                  );
                }
              });
            })
            .catch((error) => {
              // Reset loginInProcess so the user is not stuck on the
              // "Signing in" spinner if user attribute fetch fails.
              this.setState({
                loginInProcess: false,
                loginError: 'Failed to fetch user information. Please try again.',
              });
              this.props.hideLoader();
              toast.error('Failed to fetch user information. Please try again.');
            });
        } else {
          // Handle unexpected authentication state
          this.setState({
            loginInProcess: false,
            loginError: 'Unexpected authentication state. Please try again.',
          });
          this.props.hideLoader();
          toast.error('Unexpected authentication state. Please try again.');
        }
      } else {
        let attempts = this.getWithExpiry('login_attempts');
        attempts = attempts ? parseInt(attempts) : 0;
        attempts++;
        this.setWithExpiry('login_attempts', attempts, 60000 * 20);
        this.setState({
          loginError: err.message,
          loginInProcess: false,
        });
        this.props.hideLoader();
      }
    });
  }

  resetPassword() {
    const { newPassword, confirmPassword } = this.state;
    const strongRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`])\S{8,99}$/;

    // Validation
    if (newPassword === '' || !newPassword) {
      this.errorPopup('Password is required.');
      return;
    } else if (!strongRegex.test(newPassword)) {
      this.errorPopup(
        'Your password must be Minimum eight characters, Maximum ninety-nine characters, at least one uppercase letter, one lowercase letter, one number and one special character'
      );
      return;
    }
    if (confirmPassword === '' || !confirmPassword) {
      this.errorPopup('Confirm password is required.');
      return;
    }
    if (newPassword !== confirmPassword) {
      this.setState({
        NewPasswordError: 'New password and confirm password do not match.', // NOSONAR: This is a user-facing error message, not a hardcoded password
      });
      return;
    }

    // Clear previous errors
    this.errorPopup('');

    // Execute password change
    this.props.completeNewPassword(this.user, confirmPassword, async (error, response) => {
      // Handle password change failure
      if (error) {
        this.setState({
          NewPasswordError: error.message || 'Failed to update password. Please try again.',
        });
        return; // Exit early on error
      }

      // Password change successful
      try {
        // Get the updated user object
        const completedUser = response || this.user;

        // Show loader while fetching user attributes
        this.props.showLoader();

        // Fetch user attributes after successful password change (AWS Amplify v6)
        const attributes = await fetchUserAttributes();

        // Store attributes in user object
        this.user = { ...completedUser, attributes };
        this.mobileNumber = attributes?.phone_number || '';

        // Hide loader after fetching attributes
        this.props.hideLoader();

        // Get current configuration based on login option
        const currentConfig = localStorage.login_option === 'old' ? config_old : config;
        const currentUserPoolId = currentConfig?.aws_user_pools_id;

        // Define allowed user pools for MFA
        const mfaEnabledPools = ['us-east-1_QVsIWZSUU', 'us-east-1_G4ZeXmOD1'];

        // Check if current pool requires MFA
        const shouldEnableMFA = mfaEnabledPools.includes(currentUserPoolId);

        if (shouldEnableMFA) {
          // Check if user has a phone number for MFA
          const phoneNumber =
            attributes?.phone_number || this.mobileNumber || this.user?.attributes?.phone_number;

          if (phoneNumber) {
            this.setState({
              loginError: '',
              NewPasswordError: '',
              resetPasswordModal: false,
              otpModal: false,
              loginInProcess: false,
            });
          } else {
            this.setState({
              loginError:
                'Password updated successfully. MFA requires a phone number. Please contact support.',
              NewPasswordError: '',
              resetPasswordModal: false,
              otpModal: false,
              loginInProcess: false,
            });
          }
        } else {
          this.setState({
            loginError: '',
            NewPasswordError: '',
            resetPasswordModal: false,
            otpModal: false,
            loginInProcess: false,
          });
        }
      } catch (unexpectedError) {
        // Hide loader on error
        this.props.hideLoader();

        // Password was changed but something else failed
        this.setState({
          loginError: 'Password updated but encountered an error. Please try logging in again.',
          NewPasswordError: '',
          resetPasswordModal: false,
          otpModal: false,
          loginInProcess: false,
        });
      }
    });
  }

  errorPopup(errorMessage) {
    this.setState({
      NewPasswordErrorMessage: errorMessage,
    });
  }

  updateInput(e) {
    switch (e.target.id) {
      case 'username':
        this.setState({
          username: e.target.value.toLowerCase().trim(),
        });
        break;
      case 'password':
        this.setState({
          password: e.target.value.trim(),
        });
        break;
      case 'otp':
        this.setState({ otp: e.target.value });
        break;
      case 'newPassword': {
        let validationPassword = this.matchExpression(e.target.value.trim());
        this.setState({
          newPassword: e.target.value.trim(),
          validatedRules: validationPassword,
          isValidationPopupWindowOpen: true,
        });
        break;
      }
      case 'confirmPassword':
        this.setState({
          confirmPassword: e.target.value.trim(),
        });
        break;
      default:
        break;
    }
  }

  handleInputFocus() {
    this.setState(prevState => ({
      isValidationPopupWindowOpen: !prevState.isValidationPopupWindowOpen,
    }));
  }

  matchExpression(passwordStr) {
    // Optimized regex patterns to prevent ReDoS attacks
    let rgularExp = {
      minEightChar: passwordStr.length >= 8,
      containsNumber: /[0-9]/,
      containsLowercaseLetter: /[a-z]/,
      containsUppercaseLetter: /[A-Z]/,
      containsSpecialChar: /[=+\-^$*.[\]{}()?"!@#%&/\\,><':;|_~`]/,
      lessThanNintyNine: passwordStr.length <= 99,
    };

    let expMatch = {};
    expMatch.minEightChar = rgularExp.minEightChar;
    expMatch.containsNumber = rgularExp.containsNumber.test(passwordStr);
    expMatch.containsLowercaseLetter = rgularExp.containsLowercaseLetter.test(passwordStr);
    expMatch.containsUppercaseLetter = rgularExp.containsUppercaseLetter.test(passwordStr);
    expMatch.containsSpecialChar = rgularExp.containsSpecialChar.test(passwordStr);
    expMatch.lessThanNintyNine = rgularExp.lessThanNintyNine;
    return expMatch;
  }

  setWithExpiry(key, value, ttl) {
    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  clearLoginTimeout() {
    if (this.state.key && this.currentKey && this.currentKey == this.state.key) {
      this.setState({ validationError: false, loginError: false });
      localStorage.removeItem('login_attempts');
      this.handleTimeoutModal(false);
    } else {
      this.setState({ validationError: true });
    }
  }

  changeKey(e) {
    this.setState({ key: e.target.value });
  }

  getSession({ attributes }) {
    const { sub } = attributes;

    const twilioTokenValue = sub; //await sha256(sub);
    localStorage.setItem(this.twilioToken, twilioTokenValue);

    this.props.getSession((err) => {
      this.setState({ loginInProcess: false });

      if (!err) {
        let eulaAccepted = localStorage.payload
          ? JSON.parse(localStorage.payload)['custom:eulaAccepted']
          : null;

        if (!eulaAccepted || eulaAccepted == '0') {
          this.setState({
            otpModal: false,
            eulaAccepted: false,
          });
        } else {
          this.setState(
            {
              otpModal: false,
              eulaAccepted: true,
              redirectToReferrer: true,
            },
            () => {
              localStorage.removeItem('AzureRegistration');
            }
          );
        }
      } else {
        this.setState({
          otpModal: false,
          eulaAccepted: false,
        });
      }
    });
  }

  render() {
    if (this.state.checkingSession) {
      return <Spinners />;
    }

    let loginAttempts = this.getWithExpiry('login_attempts')
      ? parseInt(this.getWithExpiry('login_attempts'))
      : 0;
    const { from } = this.props.location.state || {
      from: { pathname: '/home' },
    };
    let { validatedRules, redirectToReferrer } = this.state;

    if (redirectToReferrer) {
      return <Navigate to={from} />;
    }

    return (
      <div id="loginPage">
        <div className="headerPane">
          <div className="blueColorbox"></div>
          <img className="headerLogo" src="images/logo1.svg" />
          <div className="Heading">
            <b>
              THE BETTER WAY
              <br />
              TO DO EBP AUDITS
            </b>
          </div>
        </div>

        {this.props.loader ? <Spinners /> : ''}

        {loginAttempts < 25 ? (
          <div id="signin" className={!this.state.eulaAccepted ? 'noteula' : 'eula'}>
            <div className="d-flex justify-content-center" style={{ height: '100%' }}>
              <div
                className={!this.state.eulaAccepted ? 'eulaNotAccepted' : 'eulaAccepted'}
                style={{ height: '100%' }}
              >
                {this.state.otpModal ? (
                  <div className="form" id="otpForm">
                    <div className="form-row form-group">
                      <div className="col-12" style={{ height: '17px' }}>
                        <span className="modal-close-icon" style={{ float: 'right' }}>
                          <a href="/#/Login" onClick={this.Otpclose}>
                            <img src="./images/close.png" />
                          </a>
                        </span>
                      </div>
                    </div>
                    <div className="form-row form-group">
                      <div className="col-10 offset-md-1">
                        {this.state.otpError ? (
                          <Alert color="danger">{this.state.otpError}</Alert>
                        ) : (
                          <div className="opt-message">
                            <p>A code has been sent to your mobile number</p>
                            <p>Please enter the same code here to login</p>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-row form-group">
                      <div className="col-10 offset-md-1">
                        <p className="text-left label">Otp</p>
                      </div>
                      <div className="col-10 offset-md-1">
                        <div className="input-group">
                          <input
                            key={'otp'}
                            className="form-control13"
                            value={this.state.otp}
                            autocomplete="off"
                            onChange={this.updateInput}
                            id="otp"
                            placeholder="Enter OTP "
                            name="otp"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row form-group lcs1" style={{ display: 'flex' }}>
                      {}
                    </div>
                    <div className="form-row form-group lcs3 OTPButtonRow">
                      <a className="resendBtn" onClick={this.handleLogin}>
                        Resend
                      </a>
                      <Button
                        className="button m-0"
                        size="sm"
                        style={{ backgroundColor: '#bfb03d', border: '1px solid #bfb03d' }}
                        onClick={this.handleVerify}
                      >
                        Verify OTP
                      </Button>
                    </div>
                  </div>
                ) : this.state.resetPasswordModal || !this.state.eulaAccepted ? (
                  <div className={'form '} id="resetpasswordform" style={{ height: '100%' }}>
                    {this.state.eulaAccepted ? (
                      <div>
                        <div className="form-row form-group">
                          <div className="col-12" style={{ height: '17px' }}></div>
                        </div>
                        <div className="form-row form-group">
                          <div className="col-10 offset-md-1">
                            {this.state.loginError ? (
                              <Alert color="danger">{this.state.loginError}</Alert>
                            ) : (
                              <span style={{ fontSize: '16px' }}>
                                Please update your password below
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="form-row form-group ">
                          <div className="col-10 offset-md-1">
                            <p className="text-left label">Password</p>
                          </div>
                          <div className="col-10 offset-md-1">
                            <div className="input-group">
                              <input
                                key={'password'}
                                name="password"
                                className="form-control13"
                                onFocus={this.handleInputFocus}
                                onBlur={this.handleInputFocus}
                                onChange={this.updateInput}
                                type="password"
                                id="newPassword"
                                placeholder="Enter New Password "
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-row form-group">
                          <div className="col-10 offset-md-1">
                            <p className="text-left label">Confirm Password</p>
                          </div>
                          <div className="col-10 offset-md-1">
                            <div className="input-group">
                              <input
                                key={'confirmPassword'}
                                name="cofirmpassword"
                                className="form-control13"
                                onChange={this.updateInput}
                                type="password"
                                id="confirmPassword"
                                placeholder="Enter Confirm Password "
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="form-row form-group lcs1"
                          style={{ display: 'flex', height: '130px' }}
                        >
                          {
                            <div className="validation-popup" style={{ marginLeft: '3.333333%' }}>
                              <div className="popup">
                                <ul className="validation-list">
                                  <div
                                    className={
                                      'list ' +
                                      (validatedRules.minEightChar ? ' valid ' : ' invalid')
                                    }
                                  >
                                    <img
                                      className={'validation-icons'}
                                      style={{ marginRight: '5px' }}
                                      src={
                                        './images/' +
                                        (validatedRules.minEightChar
                                          ? 'Correct_Mark.png'
                                          : 'close.png')
                                      }
                                    />
                                    Minimum 8 characters.
                                  </div>
                                  <div
                                    className={
                                      'list ' +
                                      (validatedRules.containsNumber ? ' valid ' : ' invalid')
                                    }
                                  >
                                    <img
                                      className={'validation-icons'}
                                      style={{ marginRight: '5px' }}
                                      src={
                                        './images/' +
                                        (validatedRules.containsNumber
                                          ? 'Correct_Mark.png'
                                          : 'close.png')
                                      }
                                    />
                                    At least 1 number.
                                  </div>
                                  <div
                                    className={
                                      'list ' +
                                      (validatedRules.containsUppercaseLetter
                                        ? ' valid '
                                        : ' invalid')
                                    }
                                  >
                                    <img
                                      className={'validation-icons'}
                                      style={{ marginRight: '5px' }}
                                      src={
                                        './images/' +
                                        (validatedRules.containsUppercaseLetter
                                          ? 'Correct_Mark.png'
                                          : 'close.png')
                                      }
                                    />
                                    At least 1 uppercase letter.
                                  </div>
                                  <div
                                    className={
                                      'list ' +
                                      (validatedRules.containsLowercaseLetter
                                        ? ' valid '
                                        : ' invalid')
                                    }
                                  >
                                    <img
                                      className={'validation-icons'}
                                      style={{ marginRight: '5px' }}
                                      src={
                                        './images/' +
                                        (validatedRules.containsLowercaseLetter
                                          ? 'Correct_Mark.png'
                                          : 'close.png')
                                      }
                                    />
                                    At least 1 lowercase letter.
                                  </div>
                                  <div
                                    className={
                                      'list ' +
                                      (validatedRules.containsSpecialChar ? ' valid ' : ' invalid')
                                    }
                                  >
                                    <img
                                      className={'validation-icons'}
                                      style={{ marginRight: '5px' }}
                                      src={
                                        './images/' +
                                        (validatedRules.containsSpecialChar
                                          ? 'Correct_Mark.png'
                                          : 'close.png')
                                      }
                                    />
                                    At least 1 special character( = + - ^ $ * . ! @ # % | _ ).
                                  </div>
                                  <div
                                    className={
                                      'list ' +
                                      (validatedRules.lessThanNintyNine ? ' valid ' : ' invalid')
                                    }
                                  >
                                    <img
                                      className={'validation-icons'}
                                      style={{ marginRight: '5px' }}
                                      src={
                                        './images/' +
                                        (validatedRules.lessThanNintyNine
                                          ? 'Correct_Mark.png'
                                          : 'close.png')
                                      }
                                    />
                                    Maximum 99 characters.
                                  </div>
                                </ul>
                              </div>
                            </div>
                          }
                        </div>
                        <div className="form-row form-group lcs3 loginButtonRow">
                          <div className="login-button">
                            <Button
                              className="button m-0"
                              size="sm"
                              style={{ backgroundColor: '#bfb03d', border: '1px solid #bfb03d' }}
                              onClick={this.resetPassword}
                            >
                              Submit
                            </Button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="eulaContainer">
                        <div style={{ padding: '10px', fontWeight: 'bold' }}>
                          Please read and accept below end user license agreement
                        </div>
                        <div>
                          <RichTextEditorComponent
                            readonly={true}
                            toolbarSettings={this.toolbarSettings}
                            value={this.state.EULAContent}
                          >
                            <Inject
                              services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar, Table]}
                            />
                          </RichTextEditorComponent>
                        </div>
                        <div className=" lcs3 loginButtonRow" style={{ marginTop: '9px' }}>
                          <div className="login-button">
                            <Button
                              className="button m-0"
                              size="sm"
                              style={{ backgroundColor: '#bfb03d', border: '1px solid #bfb03d' }}
                              type="button"
                              onClick={this.rejectEula}
                            >
                              Cancel
                            </Button>
                            <Button
                              className="button m-0"
                              size="sm"
                              style={{ backgroundColor: '#bfb03d', border: '1px solid #bfb03d' }}
                              type="button"
                              onClick={this.acceptEula}
                            >
                              I Accept
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <form className="form" id="loginform" onSubmit={this.handleLogin}>
                    <div className="form-row form-group">
                      <div className="col-12" style={{ height: '2px' }}></div>
                    </div>
                    {this.state.loginError && (
                      <div className="form-row form-group">
                        <div className="col-10 offset-md-1">
                          {this.state.loginError && (
                            <Alert color="danger">{this.state.loginError}</Alert>
                          )}
                        </div>
                      </div>
                    )}

                    {localStorage.login_option == 'new' &&
                      localStorage.microsoftUserActive !== undefined &&
                      localStorage.microsoftUserActive === false && (
                        <div className="form-row form-group">
                          <div className="col-10 offset-md-1">
                            <Alert color="danger">
                              User is disabled in Azure AD. Please contact administrator.
                            </Alert>
                          </div>
                        </div>
                      )}

                    {!this.state.loginInProcess &&
                    (!localStorage.hasOwnProperty('AzureRegistration') ||
                      localStorage.AzureRegistration === undefined ||
                      localStorage.AzureRegistration !== '1') ? (
                      <React.Fragment>
                        <React.Fragment>
                          <div className="form-row form-group lcs3 loginButtonRow">
                            <div className="login-button" style={{ textAlign: 'center' }}>
                              <Button
                                className="loginButton"
                                size="sm"
                                // color=""
                                style={{ backgroundColor: '#bfb03d', border: '1px solid #bfb03d' }}
                                type="button"
                                onClick={this.microsoftLogin}
                              >
                                <img style={{ width: '20px' }} src="./images/microsoft_logo.png" />{' '}
                                <span style={{ marginLeft: '10px' }}> Sign in with Microsoft</span>
                              </Button>
                              <span
                                onClick={() => this.copyToClipboard(this.encrypt(logsToCopy))}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') this.copyToClipboard(this.encrypt(logsToCopy)); }}
                                role="button"
                                tabIndex={0}
                              >
                                <i
                                  className="fa fa-copy"
                                  style={{
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                  }}
                                ></i>
                              </span>
                              <div
                                style={{
                                  fontSize: '10px',
                                  fontStyle: 'italic',
                                  marginTop: '6px',
                                }}
                              >
                                (Recommended to sign in with your corporate email)
                              </div>
                            </div>
                          </div>

                          <div className="loginSeparator">
                            <div className="word">OR</div>
                          </div>
                        </React.Fragment>

                        <React.Fragment>
                          <div className="form-row form-group ">
                            <div className="col-10 offset-md-1">
                              <p className="text-left label">Email Address</p>
                            </div>
                            <div className="col-10 offset-md-1">
                              <div className="input-group">
                                <input
                                  value={this.state.username}
                                  className="form-control13"
                                  name="email"
                                  type="email"
                                  onChange={this.updateInput}
                                  id="username"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-row form-group">
                            <div className="col-10 offset-md-1">
                              <p className="text-left label">Password</p>
                            </div>
                            <div className="col-10 offset-md-1">
                              <div className="input-group">
                                <input
                                  className="form-control13"
                                  name="login_pasword"
                                  type="password"
                                  onChange={this.updateInput}
                                  id="password"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="form-row form-group lcs1"
                            style={{ display: 'flex', marginBottom: '15px' }}
                          >
                            <div className="col-6 offset-md-1 pl-3" style={{ fontSize: '12px' }}>
                              <input type="checkbox" className="chk1" />
                              &nbsp; Remember Password
                            </div>
                            {/* <div className="col-5">
                              <span className="text-left lcs2 forgot-password-text">
                                <span className="">
                                  <NavLink
                                    className="lc1"
                                    role="button"
                                    to="/forgot-password"
                                  >
                                    Forgot Password?
                                  </NavLink>
                                </span>
                              </span>
                            </div> */}
                          </div>

                          <div
                            style={{
                              marginBottom:
                                this.state.consentCheck == null || this.state.consentCheck == true
                                  ? '5%'
                                  : '1%',
                            }}
                            className="consentCont"
                          >
                            <input
                              type="checkbox"
                              style={{ transform: 'scale(1.3)', marginLeft: '1.5px' }}
                              checked={this.state.consentCheck}
                              onChange={(e) => {
                                this.setState({ consentCheck: e.target.checked });
                              }}
                            />
                            <div style={{ fontSize: '12px' }}>
                              I hereby give my consent to receive SMS messages from Autire for the
                              purpose of verifying my account. This means that I allow Autire to
                              send me text messages to confirm my identity and ensure the security
                              of my account.
                            </div>
                          </div>

                          {this.state.consentCheck !== null && !this.state.consentCheck && (
                            <div className="consentError">
                              Check consent box for SMS verification from Autire.
                            </div>
                          )}
                          <div className="form-row form-group lcs3 loginButtonRow">
                            <div className="login-button">
                              {this.state.consentCheck == null || !this.state.consentCheck ? (
                                <Button
                                  className="loginButton"
                                  size="sm"
                                  style={{
                                    backgroundColor: '#bfb03d',
                                    border: '1px solid #bfb03d',
                                  }}
                                  onClick={() => {
                                    this.setState({ consentCheck: false });
                                  }}
                                >
                                  Log In
                                </Button>
                              ) : (
                                <Button
                                  className="loginButton"
                                  size="sm"
                                  style={{
                                    backgroundColor: '#bfb03d',
                                    border: '1px solid #bfb03d',
                                  }}
                                  type="submit"
                                >
                                  Log In
                                </Button>
                              )}
                            </div>
                          </div>
                        </React.Fragment>
                      </React.Fragment>
                    ) : (
                      <div
                        className="form-row form-group lcs3 loginButtonRow"
                        style={{ margin: '173px 0px' }}
                      >
                        <div className="login-button">
                          <p
                            className="text-left label"
                            style={{ fontSize: '18px', fontWeight: 'bold' }}
                          >
                            {localStorage.AzureRegistration == '1' ? 'Please Wait' : 'Signing in'}
                            <i class="fa fa-spinner fa-spin"></i>
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="form-row form-group lcs4">
                      <div className="col-10  offset-md-1 privacy-policy-text">
                        <p className="text-center lcs5">
                          By logging in, you agree to our <br />{' '}
                          <a href="#" style={{ color: '#bfb03d' }}>
                            Terms &amp; Conditions
                            <span className="lcs7">&nbsp;and&nbsp;</span>
                          </a>
                          <a href="#" style={{ color: '#bfb03d' }}>
                            Privacy Policy.
                          </a>
                        </p>
                      </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <NavLink
                        role="button"
                        to="/forgot-password"
                        style={{ color: '#bfb03d', fontSize: '13px' }}
                      >
                        Forgot Password?
                      </NavLink>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div id="signin" className={'eula'}>
            <div className="d-flex justify-content-center">
              <div className="form" id="otpForm">
                <div className="form-row form-group">
                  <div className="col-12" style={{ height: '17px' }}></div>
                </div>
                <div className="form-row form-group">
                  <div className="col-10 offset-md-1">
                    {this.state.validationError ? (
                      <Row style={{ marginTop: '19px' }}>
                        <Col className="col-12">
                          <Label style={{ color: 'red' }}>Please submit correct key</Label>
                        </Col>
                      </Row>
                    ) : (
                      <div
                        className="col-12 justify-content-center"
                        style={{
                          border: '2px solid #333333',
                          padding: '8px',
                          borderRadius: '11px',
                        }}
                      >
                        <h1 className="heading1">
                          <span style={{ color: ' #bfb03d ' }}>&quot;</span>You have exceeded the
                          login attempts.
                          <span style={{ color: ' #bfb03d ' }}>&quot;</span>
                        </h1>

                        <h1 className="heading1">
                          <span style={{ color: ' #bfb03d ', padding: '5px' }}>
                            <i className="fa fa-hourglass-1"></i>
                          </span>
                          Login screen will appear after 20 minutes.
                        </h1>

                        <h1 className="heading1">
                          <span style={{ color: ' #bfb03d ', padding: '5px' }}>
                            <i className="fa fa-info-circle"></i>
                          </span>
                          Want to login sooner? Call your auditor for unlock key{' '}
                        </h1>
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-row form-group">
                  <div className="col-10 offset-md-1">
                    <p className="text-left label">Unlock Key</p>
                  </div>
                  <div className="col-10 offset-md-1">
                    <div className="input-group">
                      <input
                        className="form-control13"
                        placeholder="Enter unlock key "
                        type="text"
                        value={this.state.key}
                        onChange={this.changeKey}
                        name="key"
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row form-group lcs1" style={{ display: 'flex' }}>
                  {}
                </div>
                <div className="form-row form-group lcs3 loginButtonRow">
                  <Button
                    className="loginButton"
                    size="sm"
                    color="blue"
                    onClick={this.clearLoginTimeout}
                  >
                    Clear Login Timeout
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* <div className="footer">
					{<Footer />}
				</div> */}
      </div>
    );
  }
}
function mapStateToProps(state) {
  const { loader } = state;
  return {
    loader,
  };
}
// Mapping dispatch functions to props to access easily
const mapDispatchToProps = (dispatch) => ({
  verifyOtp: (username, otp, callback) =>
    dispatch(accountActions.verifyOtp(username, otp, callback)),
  login: (user, callback) => dispatch(accountActions.login(user, callback)),
  confirmSignIn: (user, code, mfaType, callback) =>
    dispatch(accountActions.confirmSignIn(user, code, mfaType, callback)),
  completeNewPassword: (user, code, callback) =>
    dispatch(accountActions.completeNewPassword(user, code, callback)),
  getSession: (callback) => dispatch(accountActions.getSession(callback)),
  updateCognitoUser: (data, callback) => dispatch(accountActions.updateCognitoUser(data, callback)),
  logout: (callback) => dispatch(accountActions.logout(callback)),
  register: (user, callback) => dispatch(accountActions.register(user, callback)),
  sendSMSOTP: (user, callback) => dispatch(accountActions.sendSMSOTP(user, callback)),
  verifySMSOTP: (user, callback) => dispatch(accountActions.verifySMSOTP(user, callback)),
  showLoader: () => dispatch({ type: commonConstants.SHOW_LOADER }),
  hideLoader: () => dispatch({ type: commonConstants.HIDE_LOADER }),
});

Login.propTypes = {
  getSession: PropTypes.func.isRequired,
  updateCognitoUser: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

const firstHOC = connect(mapStateToProps, mapDispatchToProps)(Login);
export default withMsal(withRouter(firstHOC));
